module.exports = __webpack_public_path__ + "static/media/sign-out-bg.edbd47d4.png";